import { useModal } from '@ebay/nice-modal-react'
import { useEffect } from 'react'

import LoginModal from '../components/common/log-in-modal'
import DepositModal from '../components/wallet-management/deposit-modal'
import { decryptUser } from '../utils/user'
import useGeoCheck from './useGeoCheck'

function useContinue() {
  const logInModal = useModal(LoginModal)
  const depositModal = useModal(DepositModal)
  const { geoCheck } = useGeoCheck()
  const params = new URLSearchParams(window.location.search)

  useEffect(() => {
    const continueTo = params.get('continue')
    const user = decryptUser()

    if (!continueTo) return
    if (!user) {
      geoCheck(logInModal.show)
      return
    }

    if (continueTo === 'deposit') {
      depositModal.show()
    }
  }, [params])
}

export default useContinue
